import axios, { AxiosInstance, AxiosResponse, AxiosError } from 'axios'
import qs from 'qs'
import { ElMessage } from 'element-plus'
const config: {
  result_code: number[]
  default_headers: object
  request_timeout: number
} = {
  /**
   * 接口成功返回状态码
   */
  result_code: [0],

  /**
   * 接口请求超时时间
   */
  request_timeout: 6000,

  /**
   * 默认接口请求类型
   * 可选值：application/x-www-form-urlencoded multipart/form-data
   */
  default_headers: {
    'ContentType': 'application/x-www-form-urlencoded',
    'x-version-id': 'v1.1.4'
  }
}


// 创建axios实例
const service: AxiosInstance = axios.create({
  timeout: config.request_timeout // 请求超时时间
})
// request拦截器
service.interceptors.request.use(
  (serviceConfig) => {
    const runConfig = useRuntimeConfig()
    serviceConfig.headers = Object.assign({}, {
      ...config.default_headers, ...{
        'env': runConfig.public.sdkEnv
      }
    }, serviceConfig.headers)
    // application/x-www-form-urlencoded 格式数据格式化
    if (serviceConfig.method === 'post') {
      serviceConfig.data = qs.stringify(serviceConfig.data)
    }

    // get 参数编码
    // if (serviceConfig.method === 'get' && serviceConfig.params) {
    //   let url = serviceConfig.url as string
    //   url += '?'
    //   const keys = Object.keys(serviceConfig.params)
    //   for (const key of keys) {
    //     if (serviceConfig.params[key] !== void 0 && serviceConfig.params[key] !== null) {
    //       url += `${key}=${encodeURIComponent(serviceConfig.params[key])}&`
    //     }
    //   }
    //   url = url.substring(0, url.length - 1)
    //   serviceConfig.params = {}
    //   serviceConfig.url = serviceConfig.baseUrl + url
    // }
    return serviceConfig
  },
  (error: AxiosError) => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  (response: AxiosResponse<any>) => {
    if (response.config.responseType === 'blob') {
      // 如果是文件流，直接过
      return response
    } else if (config.result_code.includes(parseInt(response.data.code))) {
      return response.data
    } else {
      // ElMessage.error(response.data.detail)
      return response.data
    }
  },
  (error: AxiosError) => {
    console.log('err' + error) // for debug
    ElMessage.error(error.message)
    return Promise.reject(error)
  }
)

const getResultText = (code?: number) => {
  if ([100075].includes(code)) {
    return 'resultText.shiming'
  } else if ([100079].includes(code)) {
    return 'resultText.chongzhi'
  } else if ([100076, 100077, 100078, 100080].includes(code)) {
    return 'resultText.xiadan'
  }  else if ([100074].includes(code)) {
    return 'resultText.loginExpired'
  }else {
    return 'resultText.default'
  }
}
const getLoginResultText = (code?: number) => {
  if ([100206].includes(code)) {
    return 'resultText.denglu1'
  } else if ([100201].includes(code)) {
    return 'resultText.denglu2'
  }
  else {
    return 'resultText.denglu3'
  }
}
export { service, getResultText, getLoginResultText }
